"use client";

import { useGetV3RewardsAccess } from "@/gen/orval/webplatform-v3/endpoints/rewards/rewards.gen";
import type { V3RewardsAccessStateState } from "@/gen/orval/webplatform-v3/model/v3RewardsAccessStateState.gen";

export type RewardsAccess = V3RewardsAccessStateState;

/** Resolves the rewards gate state from the organization_feature-backed /v3/rewards/access endpoint. */
export function useResolvedRewardsAccess(): RewardsAccess | undefined {
  const endpointQuery = useGetV3RewardsAccess();

  if (endpointQuery.error) {
    // same pattern as the other hooks used in side-bar-menu-items, silently fail to not break the app
    return "not-eligible";
  }

  return endpointQuery.data?.state;
}
